(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["luisa-size-chart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('luisa-size-chart')) {
    customElements.define('luisa-size-chart', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.dialog = this.querySelector('dialog');
        this.opener = this.querySelector('[data-size-chart-open]');
        this.opener.addEventListener('click', () => {
          if (this.dialog.open) return;
          this.previousOverflow = document.body.style.overflow;
          this.dialog.showModal();
          document.body.style.overflow = 'hidden';
        });
        this.querySelector('[data-size-chart-close]').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => {
          document.body.style.overflow = this.previousOverflow || '';
          this.opener.focus({ preventScroll: true });
        });
      }
      disconnectedCallback() {
        if (this.dialog?.open) {
          this.dialog.close();
          document.body.style.overflow = this.previousOverflow || '';
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nadel-cart-timer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-reservation-timer')) {
    customElements.define('cart-reservation-timer', class extends HTMLElement {
      connectedCallback() {
        this.drawer = this.closest('cart-drawer');
        this.timer = this.querySelector('[data-cart-timer]');
        this.message = this.querySelector('span');
        this.initialMessage = this.message.innerHTML;
        this.storageKey = 'sofia-cart-countdown-deadline';
        this.duration = 10 * 60 * 1000;
        this.sync = this.sync.bind(this);
        this.observer = new MutationObserver(this.sync);
        this.observer.observe(this.drawer, { attributes: true, attributeFilter: ['class'] });
        this.sync();
      }

      sync() {
        if (this.drawer.classList.contains('is-empty')) {
          clearInterval(this.interval);
          this.interval = null;
          this.deadline = null;
          try { sessionStorage.removeItem(this.storageKey); } catch (_) {}
          this.message.innerHTML = this.initialMessage;
          this.timer = this.querySelector('[data-cart-timer]');
          return;
        }
        if (this.deadline) return;
        let saved = 0;
        try { saved = Number(sessionStorage.getItem(this.storageKey)); } catch (_) {}
        this.deadline = saved > 0 && saved <= Date.now() + this.duration ? saved : Date.now() + this.duration;
        try { sessionStorage.setItem(this.storageKey, String(this.deadline)); } catch (_) {}
        this.tick();
        if (this.deadline > Date.now()) this.interval = setInterval(() => this.tick(), 1000);
      }

      tick() {
        const remaining = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
        if (!remaining) {
          clearInterval(this.interval);
          this.interval = null;
          this.message.textContent = this.dataset.expiredMessage;
          return;
        }
        this.timer.textContent = `${Math.floor(remaining / 60).toString().padStart(2, '0')}:${(remaining % 60).toString().padStart(2, '0')}`;
      }

      disconnectedCallback() {
        clearInterval(this.interval);
        this.observer.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sofia-size-chart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sofia-size-chart')) {
    customElements.define('sofia-size-chart', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.dialog = this.querySelector('dialog');
        this.opener = this.querySelector('[data-size-chart-open]');
        this.opener.addEventListener('click', () => {
          if (this.dialog.open) return;
          this.previousOverflow = document.body.style.overflow;
          this.dialog.showModal();
          document.body.style.overflow = 'hidden';
        });
        this.querySelector('[data-size-chart-close]').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => {
          document.body.style.overflow = this.previousOverflow || '';
          this.opener.focus({ preventScroll: true });
        });
      }
      disconnectedCallback() {
        if (this.dialog?.open) {
          this.dialog.close();
          document.body.style.overflow = this.previousOverflow || '';
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
